exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".whole_task_div[data-v-667e02c1]{-webkit-box-shadow:1px 1px 5px #999;box-shadow:1px 1px 5px #999;padding:20px}", ""]);

// exports
